<section>
  <div class="container-fluid w-limit py-4">
    <div class="row g-4 justify-content-center">
      <div class="col-12 col-md-8">
        <div class="card card-policy-summary border rounded-3 border-0 shadow">
          <div
            class="card-header bg-white border-bottom px=3 pt-3 pb-2 d-flex flex-column flex-sm-row justify-content-start justify-content-sm-between align-items-sm-center">
            <h3 class="d-flex gap-3 align-items-center">
              <span class="icon">
                <app-icon [name]="getSafeIconName(detail.insuranceType?.icon || 'hand-heart')" [size]="36"
                  [strokeWidth]="2.2" color="#ce343c"></app-icon>
              </span>
              <span class="title lh-sm fs-5 fw-semibold text-start d-flex flex-column">
                <small class="fw-semibold text-primary small">{{
                  getCategoryLabel($any(InsuranceCategory[detail.insuranceType?.category!])) }}</small>
                <span class="small">
                  {{ detail.insuranceType?.name }}
                </span>
              </span>
            </h3>
          </div>
          <div class="card-body p-3">
            <div class="d-flex gap-2 justify-content-between align-items-center">
              <div class="d-flex flex-column flex-md-row gap-3 gap-lg-5">
                <div class="summary-mount d-flex small flex-column">
                  <small class="text-uppercase text-secondary fw-semibold small">Prima anual</small>
                  @if (isSummaryLoading) {
                  <span class="skeleton" style="width: 100px; height: 18px;"></span>
                  } @else {
                  <strong class="fw-semibold text-danger">{{ currencySymbol }} {{
                    (netPremium ?? 0) | number:'1.2-2' }}</strong>
                  }
                </div>
                @if (detail.insuranceType?.familyAllowed) {
                <div class="summary-mount d-flex small flex-column">
                  <small class="text-uppercase text-secondary fw-semibold small">Otros asegurados</small>
                  <strong class="fw-semibold text-danger">{{ otherInsured }} persona{{otherInsured > 1 ? 's' :''
                    }}</strong>
                </div>
                }
              </div>
            </div>
          </div>
          <div class="card-footer p-3 border-top bg-white p-0">
            <div class="d-flex flex-column gap-4">
              @if (!hideSyncOption) {

              <div class="d-flex flex-column gap-2">
                <div class="text-uppercase text-secondary fw-semibold small mb-2">Información Asegurado Principal</div>
                <button
                  (click)="openModalRequest.emit({ type: 'info-person', title: 'Datos del asegurado principal', icon: 'circle-user-round', description: 'Completa la información personal del asegurado principal.', detailId: detail.id! })"
                  class="btn bg-transparent text-danger btn-outline-danger rounded-3 py-2 d-flex justify-content-between gap-2 btn-modal-form-info-person"
                  type="button">
                  <div class="label-btn-form d-flex gap-2 align-items-center">
                    <app-icon name="circle-user-round" size="28" [strokeWidth]="1.75"></app-icon>
                    <h3 class="m-0 fs-6 fw-semibold text-start lh-0">
                      Haz click para introducir datos del asegurado principal
                    </h3>
                  </div>
                  <div
                    class="btn btn-sm bg-body-secondary d-flex btn-light align-items-center rounded-pill px-2 py-1 gap-1">
                    @if (isPrimaryInfoComplete) {
                    <app-icon name="circle-check" [size]="16" [strokeWidth]="2" color="currentColor"></app-icon>
                    }
                    {{ isPrimaryInfoComplete ? 'Editar' : 'Agregar' }}
                  </div>
                </button>
                @if (totalDetails > 1) {
                <div class="form-check form-switch d-flex align-items-center gap-2">
                  <input (change)="toggleUseAsPrimary($event)" [checked]="useAsPrimaryForAll"
                    [id]="'check-mark-other-asegurado-principal' + detail.id"
                    class="form-check-input focus-ring focus-ring-success" role="switch" type="checkbox">
                  <label [for]="'check-mark-other-asegurado-principal' + detail.id"
                    class="form-check-label fw-normal text-muted small">Aplicar estos datos del asegurado principal a
                    los demás seguros</label>
                </div>
                }
              </div>
              }

              @if (checkoutQuestionGroups.length && !hideSyncOption) {
              <div class="d-flex flex-column gap-2">
                <div class="text-uppercase text-secondary fw-semibold small mb-2">Otros datos del asegurado principal
                </div>
                @for (g of checkoutQuestionGroups; track g?.id) {
                <button (click)="openQuestionsForGroupRequest.emit({ group: g, detailId: detail.id! })"
                  class="btn bg-transparent text-secondary btn-outline-secondary rounded-3 py-2 d-flex justify-content-between gap-2 btn-modal-form-questions"
                  type="button">
                  <div class="label-btn-form d-flex gap-2 align-items-center">
                    <app-icon name="file-user" size="28" [strokeWidth]="1.75"></app-icon>
                    <h3 class="m-0 fs-6 fw-semibold text-start lh-0">
                      <strong class="text-primary fw-semibold">{{ g.title }}</strong>
                    </h3>
                  </div>
                  <div
                    class="btn btn-sm bg-body-secondary d-flex btn-light align-items-center rounded-pill px-2 py-1 gap-1">
                    @if (isQuestionGroupComplete(g)) {
                    <app-icon name="circle-check" [size]="16" [strokeWidth]="2" color="currentColor"></app-icon>
                    }
                    {{ isQuestionGroupComplete(g) ? 'Editar' : 'Agregar' }}
                  </div>
                </button>
                }
              </div>
              }
              @if (detail.insuranceType?.familyAllowed && otherInsured > 0) {
              <div class="d-flex flex-column gap-2">
                <div class="text-uppercase text-secondary fw-semibold small mb-2">Información de Otros Asegurado</div>

                <!-- Spouse (Partner) button: render if there is a partner on this detail -->
                @for (ip of detail.insuredPeople; track ip?.id) {
                @if (!ip?.isPrimary && ip?.person?.primaryInsuredRelation === 'Conyuge') {
                <button
                  (click)="openOtherInsuredRequest.emit({ detailId: detail.id!, insuredPersonId: ip.id!, title: 'Datos del cónyugue', description: 'Completa la información personal del cónyugue.' })"
                  class="btn bg-transparent text-secondary btn-outline-secondary rounded-3 py-2 d-flex justify-content-between gap-2 btn-modal-form-info-person"
                  type="button">
                  <div class="label-btn-form d-flex gap-2 align-items-center">
                    <app-icon name="circle-user-round" size="28" [strokeWidth]="1.75"></app-icon>
                    <h3 class="m-0 fs-6 fw-semibold text-start lh-0">
                      Haz click para introducir <strong class="fw-semibold text-primary">Datos del Cónyugue</strong>
                    </h3>
                  </div>
                  <div
                    class="btn btn-sm bg-body-secondary d-flex btn-light align-items-center rounded-pill px-2 py-1 gap-1">
                    @if (isPersonInfoComplete(ip)) {
                    <app-icon name="circle-check" [size]="16" [strokeWidth]="2" color="currentColor"></app-icon>
                    }
                    {{ isPersonInfoComplete(ip) ? 'Editar' : 'Agregar' }}
                  </div>
                </button>
                }
                }

                <!-- Children buttons: one per child on this detail -->
                @for (ip of detail.insuredPeople; track ip?.id) {
                @if (!ip?.isPrimary && ip?.person?.primaryInsuredRelation === 'Child') {
                <button
                  (click)="openOtherInsuredRequest.emit({ detailId: detail.id!, insuredPersonId: ip.id!, title: 'Datos del hijo', description: 'Completa la información personal del dependiente.' })"
                  class="btn bg-transparent text-secondary btn-outline-secondary rounded-3 py-2 d-flex justify-content-between gap-2 btn-modal-form-info-person"
                  type="button">
                  <div class="label-btn-form d-flex gap-2 align-items-center">
                    <app-icon name="circle-user-round" size="28" [strokeWidth]="1.75"></app-icon>
                    <h3 class="m-0 fs-6 fw-semibold text-start lh-0">
                      Haz click para introducir <strong class="fw-semibold text-primary">Datos del Hijo</strong>
                    </h3>
                  </div>
                  <div
                    class="btn btn-sm bg-body-secondary d-flex btn-light align-items-center rounded-pill px-2 py-1 gap-1">
                    @if (isPersonInfoComplete(ip)) {
                    <app-icon name="circle-check" [size]="16" [strokeWidth]="2" color="currentColor"></app-icon>
                    }
                    {{ isPersonInfoComplete(ip) ? 'Editar' : 'Agregar' }}
                  </div>
                </button>
                }
                }

                <!-- Other family members buttons -->
                @for (ip of detail.insuredPeople; track ip?.id) {
                @if (!ip?.isPrimary && ip?.person?.primaryInsuredRelation !== 'Conyuge' &&
                ip?.person?.primaryInsuredRelation !== 'Child' && ip?.person?.primaryInsuredRelation) {
                <button
                  (click)="openOtherInsuredRequest.emit({ detailId: detail.id!, insuredPersonId: ip.id!, title: 'Datos de ' + ip.person!.primaryInsuredRelation, description: 'Completa la información personal del familiar.' })"
                  class="btn bg-transparent text-secondary btn-outline-secondary rounded-3 py-2 d-flex justify-content-between gap-2 btn-modal-form-info-person"
                  type="button">
                  <div class="label-btn-form d-flex gap-2 align-items-center">
                    <app-icon name="circle-user-round" size="28" [strokeWidth]="1.75"></app-icon>
                    <h3 class="m-0 fs-6 fw-semibold text-start lh-0">
                      Haz click para introducir <strong class="fw-semibold text-primary">Datos de {{
                        ip.person!.primaryInsuredRelation }}</strong>
                    </h3>
                  </div>
                  <div
                    class="btn btn-sm bg-body-secondary d-flex btn-light align-items-center rounded-pill px-2 py-1 gap-1">
                    @if (isPersonInfoComplete(ip)) {
                    <app-icon name="circle-check" [size]="16" [strokeWidth]="2" color="currentColor"></app-icon>
                    }
                    {{ isPersonInfoComplete(ip) ? 'Editar' : 'Agregar' }}
                  </div>
                </button>
                }
                }

                <div class="form-check form-switch d-flex align-items-center gap-2 d-none">
                  <input class="form-check-input focus-ring focus-ring-success" id="check-mark-other-person"
                    role="switch" type="checkbox">
                  <label class="form-check-label fw-normal text-muted small" for="check-mark-other-person">Utilizar
                    estos datos en los demás seguros médicos</label>
                </div>
              </div>
              }
              @if (detail.insuranceType?.allowBeneficiaries && beneficiariesArray) {
              <app-checkout-beneficiaries [formArray]="$any(beneficiariesArray)"
                [idPrefix]="'beneficiary-' + detail.id"></app-checkout-beneficiaries>
              }
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-8">
        <hr class="border-1 border-secondary my-2" style="border-style: dashed;">
      </div>
      @if(showContact){
      <div class="col-12 col-md-8">
        <app-checkout-contact (countryChange)="countryChange.emit($event)" (stateChange)="stateChange.emit($event)"
          [countries]="countries" [filteredZipFullDescs]="filteredZipFullDescs" [filteredStates]="filteredStates"
          [form]="form"></app-checkout-contact>
      </div>
      }
    </div>
  </div>
</section>